<!--
 * @Descripttion: 
 * @version: 
 * @Author: liuchunyu
 * @Date: 2020-08-19 09:46:37
 * @LastEditors: liuchunyu
 * @LastEditTime: 2020-08-27 20:32:17
-->
<script>
import store from '../../store/index.js';
import {reduce} from 'lodash';
import {alertMessage} from '@/lib/ui';
export default {
    data() {
		    return { 
            isFlag:false,
            restArr: []
        }
    },
    computed: {
        recommendSeriesFixedItems() {
            let restRecSeries = store.recommendSeriesFixedItems.filter(item => {
              return item.checked == false
            })
            restRecSeries.map((item, index) => {
              if (index > 2) {
                item.recoChecked = false;
              }
            })
            return restRecSeries;
        },
        testId() {
            return store.testId
        }
    },
    mounted() {
    },
    methods: {
      recommenddialoglistClick(item) {//推荐车系勾选事件
        item.recoChecked = !item.recoChecked;

        // this.$clickMonitor.send({
        //   buttonId: 'recommendDialogChecked',
        //   ...store.getClickMonitorParams()
        // }); 
      },
      cancelClick(){//残忍放弃
        this.$emit('cancel','1');
      },
      submitClick(){//免费咨询提交按钮

        var data = this.recommendSeriesFixedItems;
        var array = [];
        for(var i=0;i<data.length;i++){
          if (data[i].recoChecked) {
            array.push(data[i].recoChecked)
          }
        }
        if(array.length>0){
          this.$emit('recommendDialogSubmit' , 1)
        }else{
          // alertMessage('至少选择一款车系进行对比')
          this.$emit('recommendDialogSubmit' , 2)
        }
        // this.$clickMonitor.send({
        //   buttonId: 'recommendDialogSubmit',
        //   ...store.getClickMonitorParams()
        // });  
      },
      show(){
        this.isFlag=true;
      },
      hide(){
        this.isFlag=false;
      },
      format(_price, decimals = 0) {
          if (!_price) {
              return '**';
          }
          let price = _price / 10000 + '';
          if (decimals > 0) {
              const arr = price.split('.');
              const length = arr[1] ? arr[1].length : 0;
              let complement = decimals - length;
              while (complement) {
                  if (complement < 0) {
                      arr[1] = arr[1].replace(arr[1].charAt(arr[1].length - 1), '');
                      complement++;
                      continue;
                  } else {
                      if (!arr[1]) {
                          arr[1] = '0';
                      } else {
                          arr[1] += '0';
                      }
                  }
                  complement--;
              }
              price = arr.join('.');
          }
          return price;
      },
      formatLower(_price) {
          if (_price < 10000) {
              return this.format(_price, 2);
          } else {
              return this.format(_price, 2);
          }
      },
      hidden(_price) {
          let arr = _price.split('.');
          if (arr[0].length > 1) {
              // arr[0] = arr[0].replace(arr[0].charAt(arr[0].length - 1), '*');
              let d= arr[0].split('');
              let length = d.length;
              d[length-1]='*';
              arr[0] = d.join('');
          } else {
              arr[1] = arr[1].replace(arr[1].charAt(0), '*');
          }
          return arr.join('.');
      }
    }
}
</script>
<template>
<section
    class="maskcont"
    id="successDelayBox"
    data-role-side='{"container": ".wrapper", "target": "js-maskbottom-02", "open": "slide-bottom-in", "close": "slide-bottom-out", "delay": "true", "name": "JS_maskbottom_02"}' 
    v-if="isFlag"
>
    <div class="maskcont-center mask-centercont">
        <div class="maskcont-center-inner">
            <div class="top">
                <img src="../../../assets/c2-header.png" >
            </div>
            <div class="content">
                <div class="content-inner">
                    <h2>更多优惠活动推荐</h2>
                    <h3><span class="number">95%</span>的用户还会对比以下车的最低成交价</h3>
                    
                    <ul class="recommend-list" id="oldCarList">
                        <li class="items" @click="recommenddialoglistClick(item)" :class="item.recoChecked? 'checked': '' " :key="index" v-for="(item, index) in recommendSeriesFixedItems">
                          <label class="item-label">
                              <i class="checkbox"></i>
                          </label>
                          <div class="carImg">
                              <img :src="item.seriesImg"/>
                          </div>
                          <div class="oldCarInfo">
                              <p class="series">{{item.seriesName}}</p>
                              <p class="item-price">
                                <span class="price">
                                  {{ 
                                    (item.price && item.price[1].lastMonthDealPriceFormat) || ( (item.price && item.price[0].price) ? hidden(format(item.price[0].price, 2)) + '万元' : '暂无价格')
                                    }}</span>
                              </p>
                              <!-- <p class="youhui">
                                <img class="img" src="https://2sc2.autoimg.cn/escimg/auto/g27/M00/3B/C4/440x330_0_q50_c42_autohomecar__ChsEnV7Iz5GAOy4TAAJZS9rwJcY899.jpg" alt="">
                                <span class="details">至高补贴1万元元至高补贴1万元元至高补贴1万元元</span>
                              </p> -->
                          </div>
                        </li>
                    </ul>
                    <!-- <ul class="recommend-list" id="oldCarList" v-else>
                        <li class="items" @click="recommenddialoglistClick(item)" :class="item.recoChecked? 'checked': '' " :key="index" v-for="(item, index) in recommendSeriesFixedItems">
                          <label class="item-label">
                              <i class="checkbox"></i>
                          </label>
                          <div class="carImg">
                              <img :src="item.seriesImg"/>
                          </div>
                          <div class="oldCarInfo">
                              <p class="series">{{item.seriesName}}</p>
                              <p class="item-price">
                                <span class="price">
                                  {{ 
                                    (item.price && item.price[1].lastMonthDealPriceFormat) || ( (item.price && item.price[0].price) ? hidden(format(item.price[0].price, 2)) + '万元' : '暂无价格')
                                    }}</span>
                              </p>
                          </div>
                        </li>
                    </ul> -->
                </div>
                <div class="bottom">
                    <div class="button-wrap">
                        <a href="javascript:;" class="cancel" @click="cancelClick">忍痛放弃</a>
                        <a href="javascript:;" class="submit" @click="submitClick">免费一键询底价</a>
                    </div>
                    <div class="agreement">
                        点击提交即视为同意<a href="https://www.che168.com/html/declaration.html">《个人信息保护声明》</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>
<style  scoped>

#successDelayBox {
  overflow-scrolling: touch;
}
#successDelayBox .mask-centercont {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.69);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  z-index: 99;
}
#successDelayBox .maskcont-center-inner {
  width: 100%;
}
#successDelayBox .maskcont-center-inner .top {
  height: 120px;
  margin: 0 auto;
  z-index: 1;
  text-align: center;
}
#successDelayBox .maskcont-center-inner .top img {
  width: 100%;
  max-width: 375px;
}
@media screen and (max-width: 320px) {
  #successDelayBox .maskcont-center-inner .top img {
    margin-top: 15px;
  }
}
#successDelayBox .maskcont-center-inner .content {
  width: 295px;
  height: 398px;
  margin: 0 auto;
  background: -webkit-linear-gradient(313deg, #f74580 0%, #e22a2a 100%);
  background: linear-gradient(137deg, #f74580 0%, #e22a2a 100%);
  -webkit-box-shadow: 0px -2px 8px 0px #ff574b;
          box-shadow: 0px -2px 8px 0px #ff574b;
  border-radius: 19px;
}
#successDelayBox .maskcont-center-inner .content .content-inner {
  width: 265px;
  height: 318px;
  margin: 0 auto;
  position: relative;
  top: -19px;
  bottom: 0;
  border-radius: 10px;
  background: #fff;
}
#successDelayBox .maskcont-center-inner .content .content-inner h2 {
  width: 220px;
  height: 57px;
  background: url("../../../assets/c2-header-bg2.png") no-repeat center center;
  background-size: auto 100%;
  margin: 0 auto;
  line-height: 40px;
  text-align: center;
  color: #fff;
  position: absolute;
  left: 50%;
  margin-left: -110px;
  top: -24px;
  font-weight: 400;
  font-size: 16px;
}
#successDelayBox .maskcont-center-inner .content .content-inner h3 {
  padding-top: 32px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  margin-bottom: 10px;
  text-align: left;
}
#successDelayBox .maskcont-center-inner .content .content-inner h3 .number{
  font-size: 18px;
  margin-left: 16px;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list {
  padding-top: 5px;
  height: 214px;
  overflow-y: auto;
  list-style: none;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .items {
  padding-left: 15px;
  padding-bottom: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .items .checkbox {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #dedede;
  border-radius: 50%;
  margin-right: 12px;
  margin-top: 17px;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .checked .checkbox {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADDklEQVRYR82ZTUhUURSAvzPPcRzBNpUEBS1c5CIoqDTahKsWLRIkKEihaKEzumini2Ag6GdV4M+4ssCgQBdugqBF4Er6WdkiiUDBKPwjCmYcc+bGezMjzxnH9+6bN/Le9t1zzsc5955z7rmCh08lCKVXuWAoOhScU9Cq4JhAk6lOwV8RfopiQeBzVngfPcpHSZDTNSc6AqqX4+kQ/cAt4ISOLLAMvIzmGJFxfriVdQX4J87hcI4HSrgDRNwqr7AuI4qJfyHuHxpl3UmXI2Aqzg0Uw8ARJ2Wa/9cQBhpHeb2fXEVAlaBuc4VhBb2ahrWWC4w3NDMgCbb3EtwTUN0juplhSsFVLWseFwu8aYhwXZ6SLlVRBljw3MxBwRWBLMhmOks9WQaYjpGsdVgrOdoMd3SMPvv/XYCFA/HKY6T8ERNu2g/ODqCZSuoUX2twWnXB17aF1mIK2gFM9zGmZLd7dTX7tV4UyWiSmKnPAixUiO8+JGG/GDPRHC1mxbEAUzEeAYN+afdJz+PGMYbEKvwrLHmordVxiAEqu5+O5WgzJyUVpx3FXHXW9KSNtm6My/1sjVyB9O/KwsJFycQYzGKF+EA+o62HcPcEEjLITN4mN/eiol0DhkwPTqPoOgg603Ph7ucW3NbMINl3T/Y1G4JpSceYV3C61oC6cIUU80VSMVZrnZy9wBUctmZ6cFM5NKFGew+5b7OojUVtR9v3nJuwltThjCNg6GwX9XenUBtLbD3r0IKsBq4Q4oxziCNN1MffYrRcIre+6BqyirDanWiF2PmQaEL6BIcI85LqYxpxkWZcQvoFZ7rRSjNaidoB0k84E7CYqPVKXQVIv+GsjWiWOk/NQgnk9myS8LWHriuEy1yVbxY8t1s2yKJB3TznAJpvt6pqWG2QPsPtblhNSM8tf6SJ0JlOch8mXUbOeVlZy2+KBP7SZO3F/BwmmNfOouMDfXG3Dkx+aBTc0YcFGeThUTHUgR6/2RNBYAeYdshAj4DtoIEdopfmfvszRFY4L4pTZc8Q8EspFgzhUzXPEP8Bss2h6oOH6eAAAAAASUVORK5CYII=) no-repeat center center;
  background-size: 100% 100%;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .carImg {
  width: 74px;
  height: 44px;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .carImg img {
  width: 100%;
  border-radius: 2px;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo {
  width: 145px;
  padding-left: 10px;
  overflow: hidden;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo .series {
  font-size: 14px;
  font-weight: 500;
  color: #111e36;
  line-height: 20px;
  text-overflow: ellipsis;
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
}

#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo .item-price {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 20px;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo .youhui {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 20px;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo .youhui .img{
  width: 12px;
  height: 12px;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo .youhui .details{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  margin-left: 4px;
  line-height: 12px;
  margin-bottom: 4px;
  font-size: 12px;
}


#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo .price {
  font-weight: bold;
  color: #f60;
  font-size: 14px;
  white-space: nowrap;
}
#successDelayBox .maskcont-center-inner .content .content-inner .recommend-list .oldCarInfo .off {
  margin-left: 8px;
  width: 87px;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
#successDelayBox .maskcont-center-inner .content .bottom {
  margin: -60px -11px 0 -10px;
  position: relative;
  height: 140px;
  background: url("../../../assets/c2-header-linebg3.png") no-repeat top center;
  background-size: 100% 100%;
}
#successDelayBox .maskcont-center-inner .content .bottom .button-wrap {
  padding-top: 63px;
  text-align: center;
  line-height: 42px;
}
#successDelayBox .maskcont-center-inner .content .bottom .button-wrap a {
  display: inline-block;
  font-size: 14px;
  font-weight: 550;
}
#successDelayBox .maskcont-center-inner .content .bottom .button-wrap .cancel {
  width: 87px;
  height: 42px;
  border-radius: 5px;
  border: 1px solid #e7a967;
  margin-right: 12px;
  color: #e9bb57;
}
#successDelayBox .maskcont-center-inner .content .bottom .button-wrap .submit {
  width: 156px;
  height: 42px;
  background: -webkit-gradient(linear, right top, left top, from(#ffcd94), color-stop(43%, #fae5b1), to(#feda8f));
  background: -webkit-linear-gradient(right, #ffcd94 0%, #fae5b1 43%, #feda8f 100%);
  background: linear-gradient(270deg, #ffcd94 0%, #fae5b1 43%, #feda8f 100%);
  -webkit-box-shadow: 0px 0px 9px 0px rgba(244,213,172,0.81), 0px 0px 3px 0px #e9a23a;
          box-shadow: 0px 0px 9px 0px rgba(244,213,172,0.81), 0px 0px 3px 0px #e9a23a;
  border-radius: 5px;
  color: #cd1818;
}
#successDelayBox .maskcont-center-inner .content .bottom .agreement {
  margin-top: 8px;
  text-align: center;
  line-height: 1.2;
  font-size: 10px;
  font-weight: 400;
  color: #ffe0a9;
  line-height: 14px;
}
#successDelayBox .maskcont-center-inner .content .bottom .agreement a {
  color: #fff;
}

</style>